module.exports = __webpack_public_path__ + "img/authorize.4aa8eba8.png";